import React, { useRef } from "react";
import { clickOutside } from "../../../reusable/common";
import addSpeaker from "../../../assets/img/addSpeaker.svg";
import LoadingSpinner from "../../Atom/Loading";

const TagsDropDown = ({
	data,
	setOpenSelectTicketDropdown,
	onClick,
	isChecked,
	value,
	addTagHandler,
	addNewValueinDropDown,
	addSpeakers,
	addSpeakerClickHandler,
	noDataText = "No Tags Present",
	showNoDataMessage = false,
	dropDownLoader = false
}) => {
	const wrapperRef = useRef("menu");
	clickOutside(wrapperRef, () => {
		setOpenSelectTicketDropdown(false);
	});
	const ValueNotPresentInDropDownList = enteredValue => {
		if (enteredValue && enteredValue !== "") {
			const data_dup = [...data];
			const filteredData = data_dup.filter(
				individualData => individualData.name === enteredValue
			);
			if (filteredData.length > 0) return false;
			else return true;
		}

	};
	return (
		<>
			<div ref={wrapperRef} className="custom-container position-relative ml-3">
				<div className="custom-checkbox-dropDown-container position-absolute">
					<div className="custom-checkbox-dropdown-options text-left">
						<>
							{
								!dropDownLoader ?
									data && (
										<>
											{data.length > 0 ?
												data.map((val, i) => (
													<div key={i}>
														<>
															<label className="d-flex align-items-center pointer">
																<input
																	className="custom-checkbox-input"
																	type="checkbox"
																	value={val?.name}
																	id={val?.id}
																	checked={isChecked?.includes(
																		val?.id
																	)}
																	onChange={e => {
																		onClick(e, val);
																	}}
																/>
																<span className="custom-checkbox-text-container">
																	{val?.name}
																</span>
															</label>
														</>
													</div>
												)) : (
													!ValueNotPresentInDropDownList(value) &&
													<p
														className="my-2 mr-2 mt-1 custom-message add-tag"
													>{noDataText}</p>
												)}
											{showNoDataMessage && <p
												className="my-2 mr-2 mt-1 custom-message add-tag"
											>{noDataText}</p>
											}
											{addNewValueinDropDown && ValueNotPresentInDropDownList(value) && (
												<p
													className="my-2 mr-2 mt-1 custom-message add-tag"
													onClick={addTagHandler}
												>
													Add "{value}" as a new tag
												</p>
											)}
											{
												addSpeakers && (
													<p className="d-flex mb-0 add-speaker" onClick={addSpeakerClickHandler}>
														<img className="mb-1 pr-2" src={addSpeaker}></img>
														<span className="label speaker-text">Add New Speaker</span>
													</p>
												)
											}
										</>
									) :
									(<LoadingSpinner />)
							}
						</>
					</div>
				</div>
				<style>{`
        .custom-checkbox-text-container{
            width:85%;
            word-break: break-word;
        }        
        .custom-checkbox-dropDown-container {
           	overflow-y: scroll;
            width: 102%;
            z-index: 100;
            max-height: 280px;
            background: #fff;
            left: -15px;
            border-radius: 2px;
            top: 5px;
            box-shadow: 0px 0px 12px 0px #00000040;
        }
        .custom-checkbox-dropdown-options {
            margin-top: 6px;
            max-height: calc(50vh - 220px);
            overflow-y: scroll;
            overflow-x: hidden;
            scrollbar-width: none;
        }
        .custom-checkbox-dropdown-options {
            display: block;
            width: 100%;
            padding: 8px 0px 8px 12px;
            font-size: 16px;
            color: #6D7780;
            word-break: break-all;
        }

        .custom-checkbox-dropdown-options > a:hover {
            background: #f3f2f2;
            text-decoration: none;
            cursor: pointer;
        }
        .custom-checkbox-input{
            margin-right: 0.5rem !important;
        }
        .add-tag{
            color: #333333;
            font-weight: 400!important;
            font-size: 14px!important;
			cursor: pointer;
        }
		.add-speaker{
			cursor: pointer;
		}
		.speaker-text{
			font-size: 14px;
		}
        `}</style>
			</div>
		</>
	);
};

export default TagsDropDown;